import React from 'react'
import useCards from '../../../hooks/useCards'

const ProteccionFinancieraElementalCards = () => {
  const { homeinCards } = useCards()
  
  return (
      <>
          {homeinCards(10)}

      </>
  )
} 

export default ProteccionFinancieraElementalCards